export const SET_ORGANIZATION_LIST = 'SET_ORGANIZATION_LIST'

export const SET_ORGANIZATION_VIEWS_LIST = 'SET_ORGANIZATION_VIEWS_LIST'



// WEBPACK FOOTER //
// ./src/types/organization.js